<template>
  <div class="p-3">
    <h3>{{ task.title }}</h3>
    <b>Ссылка:</b> <a :href="task.link" target="_blank">{{ task.link }}</a>
    <br>
    <b>Тип задания:</b> {{ task.type_desc }}
    <br>
    <b>Задание:</b>
    <div class="pre-formatted">
      {{ task.description }}
    </div>
    <br>
    <b>Критерии проверки:</b>
    <div class="pre-formatted">
      {{ task.check }}
    </div>
    <br>
    <b>Количество скриншотов:</b> {{ task.img_cnt }}
    <br>
    <b>Цена:</b> {{ task.price }}
    <br>
    <b>Количество:</b> {{ task.count }}
  </div>
</template>

<script>


export default {
  name: 'TaskShow',
  props: ['task'],

}
</script>